import { ref, Ref } from "@vue/composition-api";
import Vue, { CreateElement, VNode, VueConstructor } from "vue";
import { getComponent, getContextModules } from "@/lib/requireContextHelpers";
import { FormFields, ListField } from "@/types";

const modules = getContextModules<
  unknown,
  { component: VueConstructor<Vue>; listField: ListField; formFields: Ref<FormFields> }
>(require.context("./components", true, /\.\/[a-zA-Z]*\/index.ts/));

export function getListFields() {
  return modules.map(module => module.default.listField);
}

export default (selectedPayoutSystem: string | null) =>
  getComponent(modules, selectedPayoutSystem, {
    component: Vue.extend({
      render(h: CreateElement): VNode {
        return h();
      },
    }),
    listField: { text: "", value: "" },
    formFields: ref([]),
  });
